import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import { parseSearch, stringifySearch } from "./router/searchCodec";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultStaleTime: 5000,
  scrollRestoration: true,
  parseSearch,
  stringifySearch,
});

// Register things for typesafety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
